export default {"src":"/_next/static/media/gif_loader.3172290e.gif","height":1536,"width":2160};